/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Marketing_TextInputs */

const cs_form_marketing_text = /** @type {(inputs: Form_Marketing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketingový text`)
};

const en_form_marketing_text = /** @type {(inputs: Form_Marketing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing text`)
};

/**
* | output |
* | --- |
* | "Marketing text" |
*
* @param {Form_Marketing_TextInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_marketing_text = /** @type {((inputs?: Form_Marketing_TextInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Marketing_TextInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_marketing_text(inputs)
	return cs_form_marketing_text(inputs)
});